<div #spinnerContainer class="wrapper">
  <div #spinner class="spinner"></div>
</div>
